<template lang="html">
  <div class="page-reset-password-init">
    <Notification
      v-if="notification.active"
      :withinOverlay="true"
      :content="notification.content"
      :type="notification.type"
    />

    <PasswordEmailForm
      v-model="user"
      :btnLoading="btnLoading"
      :resetting="resetting"
      :errors="errors"
      @submit="resetPassword"
    />
  </div>
</template>

<script>
import PasswordEmailForm from '@/components/forms/PasswordEmailForm'
import notification from '@/mixins/notification'

import {initResetPassword} from '@/lib/users'

export default {
  name: 'init-reset-password-init',

  mixins: [notification],

  components: {
    PasswordEmailForm
  },

  data() {
    return {
      resetting: false,
      btnLoading: false,
      user: {},
      errors: {}
    }
  },

  methods: {
    resetPassword() {
      this.btnLoading = true

      initResetPassword(this.user)
        .then(() => {
          this.triggerNotification('success', 'reset email', 'sent')

          window.setTimeout(() => {
            this.resetting = true
            this.btnLoading = false
            this.user = {}
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.triggerNotification('unsuccessful', 'reset', 'email not found')
          this.errors = response.errors
          this.btnLoading = false
        })
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.page-reset-password-init
  display: flex
  flex-direction: row
  width: 100%
  align-items: center
  height: calc(100vh - #{$header-height})

  @include themify($themes)
    background: themed('color-secondary')

  h1
    text-align: center
</style>
